<template>
  <node-view-wrapper
    :class="classObject"
  >
    <node-view-content />
  </node-view-wrapper>
</template>

<script>
import {
  NodeViewWrapper,
  NodeViewContent,
  nodeViewProps,
} from '@tiptap/vue-2';

export default {
  components: {
    NodeViewWrapper,
    NodeViewContent,
  },
  props: {
    ...nodeViewProps,
    colCountLG: {
      type: Number,
      default: 2,
    },
    colCountMD: {
      type: Number,
      default: 2,
    },
    colCountXS: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    nodeProps() {
      return this.node?.attrs;
    },
    classObject() {
      const colClass = `col-${Math.floor(12 / this.nodeProps.colCountXS)} col-md-${Math.floor(12 / this.nodeProps.colCountMD)} col-lg-${Math.floor(12 / this.nodeProps.colCountLG)}`;
      return {
        [colClass]: true,
      };
    },
  },
};
</script>
